import { useNavigate } from 'react-router-dom';
import { getTenantIdFromStorage } from '../../services/authentication/supertokens';

export const useTenantNavigation = () => {
    const navigate = useNavigate();
    const tenantId = getTenantIdFromStorage();

    const getTenantPath = (path: string) => {
        // Ensure the path starts with a slash
        const normalizedPath = path.startsWith('/') ? path : `/${path}`;
        
        // If there's no tenant ID, return the normalized path
        if (!tenantId) {
            return normalizedPath;
        }
        
        // Add tenant ID to the path
        return `/${tenantId}${normalizedPath}`;
    };

    const navigateWithTenant = (path: string) => {
        navigate(getTenantPath(path));
    };

    return { navigateWithTenant, getTenantPath, tenantId };
}; 